export default "/images/e296bf308f001978d0cb501d66ba1875.png";